import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/de/app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "198dab5b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('198dab5b', __exports__)) {
    api.reload('198dab5b', __exports__)
  }
  
}


export default __exports__